import { render } from "./courseList.vue?vue&type=template&id=1a337c3c&scoped=true"
import script from "./courseList.vue?vue&type=script&lang=js"
export * from "./courseList.vue?vue&type=script&lang=js"

import "./courseList.vue?vue&type=style&index=0&id=1a337c3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a337c3c"]])

export default __exports__